import { useState } from "react";
import { ChevronDown, Trash2, Upload, X, ArrowUp, ArrowDown, Box } from "lucide-react";
import ThreeCaptureModal from "@/components/ThreeCaptureModal";

const inputCls = "w-full bg-kann-base border border-kann-border/40 rounded-md text-kann-text-pri focus:border-kann-gold focus:ring-1 focus:ring-kann-gold px-3 py-2.5 text-sm outline-none";

export default function StepEditor({ step, index, open, onToggle, onChange, onRemove, onMove, canUp, canDown, testPrefix }) {
  const [show3d, setShow3d] = useState(false);

  const uploadImage = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => onChange("image", reader.result);
    reader.readAsDataURL(f);
    e.target.value = "";
  };

  return (
    <div data-testid={`${testPrefix}-${index}`} className="bg-kann-surface border border-kann-border/30 rounded-lg overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2.5">
        <button onClick={onToggle} data-testid={`${testPrefix}-toggle-${index}`} className="flex items-center gap-2 flex-1 min-w-0 text-left">
          <ChevronDown className={`w-4 h-4 text-kann-text-sec transition-transform ${open ? "" : "-rotate-90"}`} />
          <span className="text-sm font-semibold text-kann-text-pri shrink-0">Stap {index + 1}</span>
          {!open && step.title && <span className="text-sm text-kann-text-sec truncate">— {step.title}</span>}
        </button>
        <div className="flex items-center gap-1 shrink-0">
          <button onClick={() => onMove(-1)} disabled={!canUp} className="p-1.5 rounded hover:bg-kann-surface-active text-kann-text-sec disabled:opacity-30"><ArrowUp className="w-3.5 h-3.5" /></button>
          <button onClick={() => onMove(1)} disabled={!canDown} className="p-1.5 rounded hover:bg-kann-surface-active text-kann-text-sec disabled:opacity-30"><ArrowDown className="w-3.5 h-3.5" /></button>
          <button onClick={onRemove} data-testid={`${testPrefix}-remove-${index}`} className="p-1.5 rounded hover:bg-red-500/10 text-kann-text-sec hover:text-red-500"><Trash2 className="w-3.5 h-3.5" /></button>
        </div>
      </div>
      {open && (
        <div className="px-4 pb-4 pt-1 border-t border-kann-border/20">
          <input value={step.title} onChange={(e) => onChange("title", e.target.value)} data-testid={`${testPrefix}-title-${index}`} className={`${inputCls} mb-2`} placeholder="Titel van de stap" />
          <textarea value={step.description} onChange={(e) => onChange("description", e.target.value)} data-testid={`${testPrefix}-desc-${index}`} rows={3} className={`${inputCls} resize-none`} placeholder="Uitleg van deze stap." />
          <div className="mt-2">
            {step.image ? (
              <div className="flex items-center gap-3">
                <img src={step.image} alt="" className="w-14 h-14 rounded-md object-contain bg-kann-base border border-kann-border/40" />
                <button onClick={() => onChange("image", null)} className="text-xs text-kann-text-sec hover:text-red-500 flex items-center gap-1"><X className="w-3.5 h-3.5" /> Afbeelding verwijderen</button>
              </div>
            ) : (
              <div className="flex gap-2">
                <label className="flex-1 border border-dashed border-kann-border/50 rounded-md py-2.5 text-xs text-kann-text-sec hover:border-kann-gold hover:text-kann-gold transition-colors flex items-center justify-center gap-2 cursor-pointer">
                  <Upload className="w-3.5 h-3.5" /> Afbeelding uploaden
                  <input type="file" accept="image/*" className="hidden" onChange={uploadImage} data-testid={`${testPrefix}-image-input-${index}`} />
                </label>
                <button onClick={() => setShow3d(true)} data-testid={`${testPrefix}-3d-btn-${index}`} className="border border-dashed border-kann-border/50 rounded-md px-3 py-2.5 text-xs text-kann-text-sec hover:border-kann-gold hover:text-kann-gold transition-colors flex items-center gap-2">
                  <Box className="w-3.5 h-3.5" /> 3D → tekening
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {show3d && <ThreeCaptureModal onClose={() => setShow3d(false)} onCapture={(url) => onChange("image", url)} />}
    </div>
  );
}
